import {
  withTranslation,
} from 'react-i18next';

import CommonDialogView from './CommonDialogView';

const TranslatedComponent = withTranslation()(CommonDialogView);

const Component = TranslatedComponent;

export default Component;
